var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "dynamic-image-properties-wrapper" },
    [
      _c(
        _setup.ElementLibrarySelector,
        {
          attrs: {
            disabled: _setup.disabled,
            readonly: _setup.readonlyMode,
            "hide-library-selection":
              _setup.model.isPrintArea || _vm.hideLibrarySelection,
            "readonly-options": _setup.model.isMoonPhase,
            "element-list": _setup.model.imageMap,
            "library-id": _setup.model.imageLibraryId,
            "library-type": _setup.IMAGE_TYPE,
            "selected-position": _setup.model.imageOption,
            "mixed-library": _setup.model.isLibraryIdMixed,
            "mixed-element-list": _setup.model.isImageMapMixed,
            "element-list-position": 3,
          },
          on: {
            "files-uploaded": _setup.onImageUpload,
            "load-option": _setup.onLoadOption,
            "options-reordered": _setup.onImageOptionsReordered,
            "remove-map-option": _setup.removeImageOptionFromMap,
            "remove-library": _setup.removeImageLibrary,
            "pick-library": function ($event) {
              return _setup.emit("open-image-library-selector")
            },
            "library-loaded": function ($event) {
              return _setup.emit("library-changed", $event)
            },
          },
        },
        [
          _c(
            "template",
            { slot: _setup.currentSlot },
            [
              _c(_setup.CInput, {
                staticClass: "w-25 no-fill",
                attrs: {
                  label: "Element ID",
                  type: "number",
                  min: 1,
                  placeholder: _setup.elementIdPlaceholder,
                  disabled:
                    _setup.disabled ||
                    (_vm.previewMode && !_vm.isPreviewElement),
                  pattern: /^[1-9]\d*$/,
                },
                on: { input: _setup.updateElementId },
                model: {
                  value: _setup.model.elementId,
                  callback: function ($$v) {
                    _vm.$set(_setup.model, "elementId", $$v)
                  },
                  expression: "model.elementId",
                },
              }),
              _vm._v(" "),
              _setup.model.isMoonPhase
                ? _c(_setup.CDatepicker, {
                    staticClass: "w-25 no-fill",
                    attrs: {
                      label: "Type or select a date",
                      placeholder: "Enter date",
                      disabled: _setup.disabled,
                    },
                    on: { input: _setup.onMoonPhaseDateChanged },
                    model: {
                      value: _setup.model.moonPhaseDate,
                      callback: function ($$v) {
                        _vm.$set(_setup.model, "moonPhaseDate", $$v)
                      },
                      expression: "model.moonPhaseDate",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }